export function resolveAddress(position) {

    return new Promise((resolve, reject) => {
        const google = window.google;
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: { lat: position.latitude, lng: position.longitude } }, function (
            results,
            status
        ) {
            if (status === 'OK' && results[0]) {
                resolve(results[0].formatted_address);
            } else {
                reject(status);
            }
        });
    });

}